<template>
  <div class="finance-refund-list">
    <!--  表头-->
    <div class="fr ac fz12 mt30">
      <div class="center order-list-item">产品信息</div>
      <div class="center order-list-item">产品规格</div>
      <div class="center order-list-item">设备信息</div>
      <div class="center order-list-item">配套工艺</div>
      <div class="center order-list-item">产品价格</div>
      <div class="center order-list-item">数量</div>
      <div class="center fg">操作</div>
    </div>
    <el-divider/>

    <!-- 列表-->
    <div class="order-list fz12">
      <div
          class="order-item mt20"
          v-for="(item, index) in service_list"
          :key="index"
      >
        <!--    上-->
        <div class="top">
          <span>{{ item.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ item.order_no }}</span>
          <span class="ml40 blue">{{ item.order_state_show }}</span>
        </div>

        <!--    中-->
        <div class="fr middle">
          <!-- 商品信息 -->
          <div class="order">
            <div class="fr jc ac order_left">
              <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                <el-image
                    class="goods-img fs mr10"
                    :src="item.orderGoodsBean.goods_img"
                    alt
                />
                <p class>{{ item.orderGoodsBean.goods_name }}{{ item.orderGoodsBean.goods_standard_name }}</p>
              </div>
              <div class="center order-list-item">-</div>
              <div class="center order-list-item">-</div>

              <div class="center cursor order-list-item blue">-</div>
              <div class="center order-list-item">
                ￥{{ item.orderGoodsBean.goods_price }}{{ item.orderGoodsBean.price_unit }}
              </div>
              <div class="center order-list-item">{{
                  item.orderGoodsBean.goods_num
                }}{{ item.orderGoodsBean.specification_unit }}
              </div>
              <div class="center order-list-item red"></div>
            </div>
          </div>
          <!-- 操作 -->
          <div class="fc jc ac fg fs operating">
            <p class="mt10 cursor blue" @click="confirm(item)" v-if="hasPermission(906)">确认收款</p>
          </div>
        </div>

        <!--                下-->
        <div class="p20 fz14 bottom" style="text-align: right">
          <div>
            <span>折扣退款</span>
            <span class="blue">￥{{ item.handle_platform_price }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="fr jc ac mt30 mb30">
      <el-pagination
          :hide-on-single-page="true"
          :current-page.sync="page"
          layout="prev, pager, next"
          :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "refund",
  data() {
    return {
      service_list: [],
      page: 1,
      total: 0
    }
  },
  watch: {
    page(n) {
      this.getOrderRefunds();
    }
  },
  mounted() {
    this.getOrderRefunds();
  },
  methods: {
    confirm(item) {
      this.set("feedback", item, 1);
      this.go("/reunddetail");
    },
    getOrderRefunds() {
      this.post("orderInterfaces/v1.0/getOrderRefunds", {
        page: this.page,
      }).then((res) => {
        this.service_list = res.data;
        this.total = res.total;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.finance-refund-list {
  background-color: #fff;

  .order-list-item {
    &:nth-of-type(1) {
      width: 270px;
    }

    &:nth-of-type(2) {
      width: 88px;
    }

    &:nth-of-type(3) {
      width: 110px;
    }

    &:nth-of-type(4) {
      width: 88px;
    }

    &:nth-of-type(5) {
      width: 88px;
    }

    &:nth-of-type(6) {
      width: 88px;
    }

    &:nth-of-type(7) {
      width: 88px;
    }
  }

  .order-list {
    .order-item {
      border: 1px solid #e5e5e5;

      .goods-img {
        width: 80px;
        height: 80px;
      }

      .top {
        background-color: #f0f6ff;
        padding: 14px;
      }

      .middle {
        border-bottom: 1px solid #e5e5e5;

        .order {
          .order-left {
            border-right: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;

            &:last-child {
              border-bottom: none;
            }


          }

          .operating {
            p {
              margin-top: 10px;

              &:nth-of-type(1) {
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/finance/components/refund.vue